<template>
    <div class="dropdown-shop">
        <div class="dropdown-shop__overlay" v-if="showDropdownList" @click="toggleDropdown"/>
        <p class="dropdown-shop__title">
            {{ title }}
        </p>
        <button @click="toggleDropdown" class="dropdown-shop__button">
            {{ dropdownButton }}
            <Icon 
                icon="arrow-down" 
                class="dropdown-shop__button__icon" 
                :class="{'dropdown-shop__button__icon-rotated': showDropdownList}"
            />
        </button>
        <ul v-if="showDropdownList" class="dropdown-shop__items">
            <li 
                v-for="(item, index) in data" 
                :key="item + index" 
                class="dropdown-shop__item"
                @click="checkItem(item)"
            >
                {{ item }}
            </li>
        </ul>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
export default {
    name: 'DropdownShop',
    components: {
        Icon
    },
    props: {
        title: {
            type: String,
            default: () => ''
        },
        data: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            dropdownButton: this.data[0],
            showDropdownList: false
        }
    },
    mounted() {
        this.$emit('checkedShop', this.dropdownButton)
    },
    methods: {
        toggleDropdown() {
            this.showDropdownList = !this.showDropdownList
        },
        checkItem(item) {
            this.dropdownButton = item
            this.$emit('checkedShop', item)
            this.toggleDropdown()
        }
    },
}
</script>

<style lang="scss" scoped>
$button_height: 48px;
$border: 1px solid #CBD5E0;
$radius: 4px;
$text_color: #333333;
$button_padding: 12px 16px;
$shadow: 0px 12px 12px -6px rgba(113, 128, 150, 0.16), 0px 0px 1px rgba(113, 128, 150, 0.2);
$list_radius: 8px;
$white: #ffffff;
$item_shadow: inset 0px -1px 0px #EDF2F7;
$transition: all 0.2s ease;
.dropdown-shop {
    position: relative;
    &__overlay {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
    &__title {
        font-size: 14px;
        line-height: 20px;
        color: $text_color;
        margin-left: 8px;
        margin-bottom: 8px;
    }
    &__button {
        width: 100%;
        height: $button_height;
        border: $border;
        border-radius: $radius;
        padding: $button_padding;
        position: relative;
        text-align: left;
        height: 42px;
        overflow: hidden;
        white-space: nowrap;
        padding-right: 42px;
        text-overflow: ellipsis;
        line-height: 50%;
        &__icon {
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(-100%, -50%) rotate(-0deg);
            transition: $transition;
            transform-origin: center;
        }
        &__icon-rotated {
            transform: translate(-100%, -50%) rotate(-180deg);
        }
    }
    &__items {
        width: 100%;
        margin: 0;
        position: absolute;
        top: 100%;
        left: 0;
        box-shadow: $shadow;
        border-radius: $list_radius;
        background: $white;
        padding: 0;
        max-height: 220px;
        overflow-y: auto;
    }
    &__item {
        padding: 12px;
        cursor: pointer;
        transition: $transition;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &:not(:last-child) {
            box-shadow: $item_shadow;
        }
        &:hover {
            background: #F4F7FA;
        }
    }
}
</style>